import type { RouteRecordRaw } from 'vue-router';

export const labelsRoute: RouteRecordRaw = {
  path: '/settings/labels',
  name: 'Labels',
  component: () => import('./pages/LabelsPage.vue'),
  meta: {
    title: 'Labels',
    layout: 'main',
    // Manage-gated like the Teams/Users settings routes — viewing the dictionary
    // happens in pickers and filters; this page exists to edit it.
    authorize: ({ isGranted }) => isGranted('dt:core:labels:create'),
  },
};
